<template>
    <div class="Seguro-Colectivo-Salud">
        <div class="title">
                <span>Seguros</span>
                <h1>Empresariales</h1>
                <div id="contactForm">
                    <label for="">Conoce más sobre soluciones de seguros</label>
                    <div id="hubcontactForm"></div>
                </div>
        </div>
        <div class="info top">
                <h1>Seguro de Cumplimiento de Disposiciones Legales</h1>
                <p>Cuide el patrimonio de una entidad u organismo estatal y garantice el cumplimiento de las obligaciones
                contempladas en leyes, decretos, ordenanzas, acuerdos, resoluciones, entre otras normas.
                </p>
        </div>
        <div class="services">
            <center>
                <h1>Su empresa debe saber sobre este seguro que:</h1>
                <div v-for="(slide, i) in slides" :key="i">
                    <div v-for="(service, y) in slide.service" :key="y">
                        <div class="service-img">
                            <div>
                                <img :src="service.img" alt="">
                                <p v-html="service.text"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Trabajamos para ofrecerles a nuestros clientes soluciones integrales y personalizadas que atiendan sus necesidades.
                <br>
                <br>
                Con el Seguro de Cumplimiento de Disposiciones Legales protegemos el patrimonio de una entidad estatal frente a los perjuicios que
                puede generarle el incumplimiento de las obligaciones legales a cargo del tomador garantizado.
                <br>
                <br>
                Reciba nuestro apoyo en el cumplimiento de las normas en pro de su tranquilidad. <span>¡Permítanos asesorarlo!</span>
                </p>
            </center>
        </div>
        <div class="cobertura-principal">
            <center><h1>¿Qué se cubre?</h1></center>
            <p>Los perjuicios que puede ocasionar a la entidad estatal u organismo público el incumplimiento de obligaciones derivadas de leyes, decretos,
            resoluciones, reglamentos, ordenanzas, etc.</p>
            <center><h1>¿Qué no cubre?</h1></center>
            <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
            <p>Fuerza mayor.</p>
            <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
            <p>Caso fortuito o cualquier otra causal de exoneración de responsabilidad del deudor de la obligación contenida en la disposición
            legal garantizada.</p>
        </div>
        <div class="connect">
            <img src="@/assets/bg-llamado-accion.webp" alt="">
            <h1>¿Qué empresas se pueden asegurar?</h1>
            <p>El asegurado deberá ser siempre una entidad u organismo estatal. El tomador podrá ser cualquier persona natural o jurídica.</p>
        </div>
        <div class="info">
            <h1>Seguro de Cumplimiento a Favor de Entidades Estatales</h1>
            <p>Garantice el cumplimiento de los compromisos estipulados en una negociación o un contrato que celebre
            con sus proveedores o contratistas.
            </p>
        </div>
        <div class="services">
            <center>
                <h1>Su empresa debe saber sobre este seguro que:</h1>
                <div v-for="(slide, i) in slides2" :key="i">
                    <div v-for="(service, y) in slide.service" :key="y">
                        <div class="service-img">
                            <div>
                                <img :src="service.img" alt="">
                                <p v-html="service.text"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Si administra una entidad pública conocerá, por experiencia, la importancia de contar con proveedores para llevar a cabo sus
                proyectos. Asegure los acuerdos entre ambas partes y evite inconformidades durante la ejecución del contrato.
                <br>
                <br>
                Con nuestro Seguro de Cumplimiento a Favor de Entidades Estatales respaldará su gestión administrativa y sentirá tranquilidad a la
                hora de firmar contratos, ofertas mercantiles, órdenes de compra u otros documentos con los que el patrimonio de su organización está en
                juego.
                <br>
                <br>
                Por ejemplo: si requiere construir obras públicas, como parques o zonas de entretenimiento, le será de gran ayuda contar con nosotros para
                que apoye el cumplimiento de las obligaciones asumidas por el contratista que ejecutará el proyecto, así no solo protegerá el patrimonio
                público sino que también garantizará el desarrollo próspero de sus planes.
                <br>
                <br>
                Garantice las obligaciones acordadas con sus contratistas. <span>¡Permítanos asesorarlo y tome decisiones acertadas!</span>
                </p>
            </center>
        </div>
        <div class="slide-cobertura-opcional">
            <center><h1>¿Qué cubre?</h1></center>
            <VueSlickCarousel
            class="slider"
            ref="slick"
            :autoplay="true"
            :dots="true"
            :arrows="false">
                <div v-for="(slide, i) in coberturaOpcional" :key="i">
                    <div class="cobertura-principal-slide">
                        <div>
                            <img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt="">
                            <label for="">{{slide.label}}</label>
                        </div>
                       <p v-html="slide.p"></p>
                    </div>
                </div>
            </VueSlickCarousel>
        </div>
        <div class="texto">
            <center><h1>¿Qué no cubre?</h1></center>
            <center class="box">
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                <p>Daños causados por el contratista a los bienes de la entidad estatal no destinados para la ejecución del contrato.</p>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                <p>El uso inadecuado o falta de mantenimiento preventivo al que está obligada la entidad estatal como asegurada.</p>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                <p>El deterioro normal que sufran los bienes de la entidad estatal como consecuencia de su uso durante el desarrollo de la obra.</p>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                <p>La causa extraña, es decir la fuerza mayor o caso fortuito, el hecho de un tercero o la culpa exclusiva de la víctima.</p>
            </center>
        </div>
        <div class="connect">
            <img src="@/assets/bg-llamado-accion.webp" alt="">
            <h1>¿Qué organizaciones se pueden asegurar?</h1>
            <p>Cualquier entidad estatal puede solicitar a sus contratistas el otorgamiento de este seguro para garantizar el cumplimiento de los contratos
            suscritos por estos.</p>
        </div>
        <div class="info">
            <h1>Seguro de Cumplimiento a Favor de Particulares</h1>
            <p>Celebrar un contrato trae riesgos asociados a su cumplimento. Aunque las partes se comprometen, hay
            variables que podrían interferir en su desarrollo oportuno. ¡Cuide su empresa frente al incumplimiento!
            </p>
        </div>
        <div class="services">
            <center>
                <h1>Con este seguro de cumplimiento su empresa puede:</h1>
                <div v-for="(slide, i) in slides3" :key="i">
                    <div v-for="(service, y) in slide.service" :key="y">
                        <div class="service-img">
                            <div>
                                <img :src="service.img" alt="">
                                <p v-html="service.text"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Si tiene a su cargo la administración o celebración de contratos como persona jurídica o natural, nunca se está exento de afrontar
                incumplimientos por parte de sus contratistas. Por ello, es importante que respalde con un seguro los acuerdos que establezca a través
                de contratos, órdenes de compra, ofertas mercantiles, entre otros documentos.
                <br>
                <br>
                Invertir en un negocio, incluso en una pequeña empresa, es un esfuerzo que debe ser garantizado. Ser cuidadoso al elegir un proveedor es
                fundamental para que su proyecto avance como espera, así como también es importante tener el mejor respaldo que le permita alcanzar sus
                objetivos con tranquilidad y éxito.
                </p>
            </center>
        </div>
        <div class="slide-cobertura-opcional">
            <center><h1>¿Qué cubre?</h1></center>
            <VueSlickCarousel
            class="slider"
            ref="slick"
            :autoplay="true"
            :dots="true"
            :arrows="false">
                <div v-for="(slide, i) in coberturaOpcional2" :key="i">
                    <div class="cobertura-principal-slide">
                        <div>
                            <img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt="">
                            <label for="">{{slide.label}}</label>
                        </div>
                       <p v-html="slide.p"></p>
                    </div>
                </div>
            </VueSlickCarousel>
        </div>
        <div class="texto">
            <center><h1>¿Qué no cubre?</h1></center>
            <center class="box">
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                <p>Sanciones o multas impuestas al contratista.</p>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                <p>Lucro cesante.</p>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                <p>Deterioro de bienes por falta de mantenimiento preventivo.</p>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                <p>Defectos de fabricación.</p>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                <p>Los daños causados por el contratista a los bienes que no tengan relación con la ejecución del contrato.</p>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                <p>Las demás exclusiones señaladas en las condiciones generales y particulares del contrato de seguro.</p>
            </center>
        </div>
        <div class="connect">
            <img src="@/assets/bg-llamado-accion.webp" alt="">
            <h1>¿Quiénes se pueden asegurar?</h1>
            <p>Cualquier persona natural o jurídica de naturaleza privada puede solicitar a sus contratistas el Seguro de Cumplimiento a Favor de
            Particulares. El contratante será el asegurado</p>
        </div>
        <div class="info">
            <h1>Seguro de Caución Judicial</h1>
            <p>Respalde las decisiones de las autoridades judiciales y administrativas para que se cumplan.</p>
        </div>
        <div class="services">
            <center>
                <h1>Con este seguro de cumplimiento su empresa puede:</h1>
                <div v-for="(slide, i) in slides4" :key="i">
                    <div v-for="(service, y) in slide.service" :key="y">
                        <div class="service-img">
                            <div>
                                <img :src="service.img" alt="">
                                <p v-html="service.text"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Las cauciones judiciales son garantías fijadas en diferentes leyes que pretenden servir al cumplimiento de obligaciones que surgen a cargo
                de una de las partes vinculadas en un proceso judicial o administrativo y, en este sentido, su origen y fundamento será siempre una norma.
                <br>
                <br>
                Así pues, el objeto de la caución y el valor asegurado de la misma está determinado normalmente en la ley o, en su defecto, por la
                autoridad judicial o administrativa responsable del proceso.
                </p>
            </center>
        </div>
        <div class="texto">
            <center><h1>¿A quiénes beneficia el seguro?</h1></center>
            <center class="box">
                <p>Las cauciones judiciales cumplen diferentes propósitos dependiendo de la norma que sirva de fundamento para su expedición, beneficiando a
                las partes que intervienen en procesos judiciales o administrativos.
                </p>
            </center>
        </div>
        <div class="texto">
            <center><h1>¿Qué cubre?</h1></center>
            <center class="box">
                <p>El Seguro de Caución Judicial cubre hasta el valor asegurado dependiendo de la norma que sirva de base para su expedición, el pago de
                daños que se generen a la contraparte por el incumplimiento de una decisión judicial o administrativa o, incluso, el valor mismo de las
                pretensiones del demandante.
                </p>
            </center>
        </div>
         <div class="texto">
            <center><h1>¿Qué no cubre?</h1></center>
            <center class="box">
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                <p>Lucro cesante.</p>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                <p>Fuerza mayor.</p>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                <p>Caso fortuito.</p>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                <p>Cualquier otra de exoneración de responsabilidad del garantizado.</p>
            </center>
        </div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: 'Cumplimiento-disposiciones-legales',
    metaInfo() {
        return {
            title: 'Seguro de Cumplimiento de Disposiciones Legales',
            titleTemplate: '%s | Interseguros',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: 'Cuide el patrimonio de una entidad u organismo estatal y garantice el cumplimiento de las obligaciones contempladas en leyes, decretos, ordenanzas, acuerdos, resoluciones, entre otras normas.'
            },
            {
                vmid: 'keywords',
                name: 'keywords',
                content: 'Asesor en riesgos laborales, intermediación ARL, Control de ARL, Seguros ARL, Administradora de Riesgo Laborales, Seguros Generales, Seguros Empresariales, Seguros Personales'
            },
            {
                vmid: 'image',
                name: 'image',
                content: require('@/assets/logo/logo.webp')
            },
            {
                vmid: 'robots',
                name: 'robots',
                content: 'index, follow'
            },
            {
                vmid: 'twitter:card',
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                vmid: 'twitter:title',
                name: 'twitter:title',
                content: 'Interseguros'
            },
            {
                vmid: 'twitter:site',
                name: 'twitter:site',
                content: '@Interseguros'
            },
            {
                vmid: 'twitter:description',
                name: 'twitter:description',
                content: 'Recibe asesoría para cotizar y contratar diferentes tipos de seguros para empresas.'
            },
            {
                vmid: 'twitter:image',
                name: 'twitter:image',
                content: require('@/assets/image-people.png')
            }]
        }
    },
    components: {
        Aliados,
        VueSlickCarousel
    },
    data() {
        return {
            coberturaOpcional: [
                {
                    label: 'Seriedad de la oferta',
                    p: 'Si el contratista no otorga la garantía de cumplimiento del contrato, no amplía la vigencia de esta, retira la oferta o no firma el contrato sin justa causa, tendrá nuestro apoyo'
                },
                {
                    label: 'Buen manejo y correcta inversión del anticipo',
                    p: 'Aseguramos a su entidad estatal ante el uso indebido que el contratista haga del dinero anticipado para ejecutar el contrato'
                },
                {
                    label: 'Cumplimiento',
                    p: 'Se cubre a la entidad estatal por el incumplimiento total o parcial del contrato ejecutado por el contratista. Además, asumimos el pago de las multas impuestas por la entidad estatal al contratista'
                },
                {
                    label: 'Pago de salarios, prestaciones sociales e indemnizaciones laborales',
                    p: 'Se garantiza el pago de salarios y prestaciones sociales al personal que participe en la ejecución del contrato en caso de que el contratista haya incumplido con estas obligaciones'
                },
                {
                    label: 'Calidad del servicio',
                    p: 'Lo apoyamos en caso de una deficiente calidad del servicio prestado por parte del proveedor'
                }
            ],
            coberturaOpcional2: [
                {
                    label: 'Seriedad de la oferta',
                    p: 'Se asumen los perjuicios que sufra el asegurado por daño emergente debido a la no firma del contrato para el cual el proveedor presentó una oferta o propuesta'
                },
                {
                    label: 'Buen manejo y correcta inversión del anticipo',
                    p: 'Lo protegemos ante el mal manejo e incorrecta inversión del anticipo que su empresa, como contratante, le haya entregado al contratista, así como la apropiación indebida que el contratista haga de los dineros o bienes que se le hayan entregado como anticipo.'
                },
                {
                    label: 'Cumplimiento',
                    p: 'Cubrimos, en los términos del seguro, los perjuicios que su contratista le ocasione en caso de que incumpla el contrato'
                },
                {
                    label: 'Pago de salarios, prestaciones sociales e indemnizaciones laborales',
                    p: 'Garantizamos el pago de salarios, prestaciones sociales legales e indemnizaciones laborales que el contratista haya incumplido a los trabajadores que intervinieron en la ejecución del contrato.'
                },
                {
                    label: 'Estabilidad y calidad de la obra',
                    p: 'Lo cubrimos en caso de daño o deterioro del proyecto por mala calidad en su ejecución'
                }
            ],
            slides: [
                {
                    service: [
                        {
                            text: 'Le permite amparar a una organización estatal asegurada frente a perjuicios originados en el incumplimiento de disposiciones legales.',
                            img: require('@/assets/Cumplimiento-Disposiciones-Legales/1.png')
                        },
                        {
                            text: 'La vigencia será máximo de cinco años y no podrá ser inferior al plazo estipulado en el decreto, ley, resolución u otra norma.',
                            img: require('@/assets/Cumplimiento-Disposiciones-Legales/2.png')
                        },
                        {
                            text: 'Para su tranquilidad, el contrato del seguro no podrá ser revocado.',
                            img: require('@/assets/Cumplimiento-Disposiciones-Legales/3.png')
                        }
                    ]
                }
            ],
            slides2: [
                {
                    service: [
                        {
                            text: 'Brindar protección y seguridad a su entidad estatal ante la falla de los contratistas.',
                            img: require('@/assets/Cumplimiento-Disposiciones-Legales/4.png')
                        },
                        {
                            text: 'Preservar el patrimonio que requiere para llevar a cabo sus planes.',
                            img: require('@/assets/Cumplimiento-Disposiciones-Legales/5.png')
                        },
                        {
                            text: 'Resguardar el funcionamiento de las entidades estatales.',
                            img: require('@/assets/Cumplimiento-Disposiciones-Legales/6.png')
                        }
                    ]
                }
            ],
            slides3: [
                {
                    service: [
                        {
                            text: 'Trabajar con tranquilidad al proteger los contratos que un contratista ejecute para su empresa.',
                            img: require('@/assets/Cumplimiento-Disposiciones-Legales/7.png')
                        },
                        {
                            text: 'Respaldar su organización ante el incumplimiento de sus contratistas.',
                            img: require('@/assets/Cumplimiento-Disposiciones-Legales/8.png')
                        },
                        {
                            text: 'Posibilitar el desarrollo oportuno y exitoso de sus proyectos.',
                            img: require('@/assets/Cumplimiento-Disposiciones-Legales/9.png')
                        }
                    ]
                }
            ],
            slides4: [
                {
                    service: [
                        {
                            text: 'Ninguna de las partes puede revocarlo unilateralmente.',
                            img: require('@/assets/Cumplimiento-Disposiciones-Legales/10.png')
                        },
                        {
                            text: 'Su vigencia será hasta que termine el proceso.',
                            img: require('@/assets/Cumplimiento-Disposiciones-Legales/11.png')
                        },
                        {
                            text: 'No opera el fenómeno de la reticencia (si los clientes no declaran sinceramente el estado del riesgo u omiten datos, el contrato del seguro será anulado).',
                            img: require('@/assets/Cumplimiento-Disposiciones-Legales/12.png')
                        }
                    ]
                }
            ]
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>
<style>
    .cobertura-principal-slide > p > span {
        font-weight: bold;
        margin-left: 5em;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 25px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 5px;
        margin-bottom: 15px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
</style>

<style scoped>
    .title {
        background-image: url('../../../assets/servicios-empresariales-bg.png');
        padding: 200px 200px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        width: 60%;
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 200px;
        font-size: 40px;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 200px;
        margin-top: 10px;
        font-size: 18px;
    }
    .services {
        padding: 50px 300px;
        width: 100%;
    }
    .services > center {
        display: contents;
    }
    .services > center > div {
        display: inline-block;
        width: 100%;
    }
    .services > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 50px;
        font-size: 30px;
    }
    .services > center > div > div {
        display: inline-flex;
        width: 33.333333333%;
        float: left;
    }
    .services > center > div > div > .service-img {
        width: 100%;
    }
    .services > center > div > div > .service-img > div {
        position: relative;
        width: 100%;
        height: 100%;
        padding: auto;
        margin-bottom: 10px;
        transition: margin-top .5s ease-out 100ms;
    }
    .services > center > div > div > .service-img > div:hover {
        margin-top: -10px;
    }
    .services > center > div > div > .service-img > div >  img {
        width: 100%;
        height: auto;
    }
    .services > center > div > div > .service-img > div >  p {
        font-family: 'JR';
        font-size: 18px;
    }
    .texto {
        width: 100%;
        padding: 10px 300px;
    }
    .texto > .box-title {
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .texto > .box-title > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box {
        padding: 20px 20px;
        text-align: left;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        margin-bottom: 10px;
    }
    .texto > center > p {
        font-family: 'JR';
    }
    .texto > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
    }
    .texto > center > p > span{
        font-weight: bold;
    }
    .service {
        padding: 20px 300px;
        width: 100%;
    }
    .service > div {
        width: 100%;
        margin-top: 20px;
    }
    .service > div {
        width: 100%;
        display: flex;
    }
    .service > div > div > img {
        width: 350px;
        float: left;
    }
    .service > div > .imgbox {
        display: block;
        width: 350px;
        z-index: 99999;
    }
    .service > div > .box {
        margin-left: -300px;
        margin-top: 110px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 30px 30px 350px;
    }
    .service > div > .box2 {
        margin-right: -300px;
        margin-top: 60px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 350px 100px 30px;
    }
    .service > div > .right{
        position: absolute;
        right: 15%;
    }
    .service > div > .box > h1 {
        position: relative;
        font-family: 'JBD';
        color:#2d4f98;
        margin-top: -120px;
        margin-bottom: 60px;
        text-align: left;
    }
    .service > div > .box > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > div > .box2 > h1 {
        position: relative;
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 10px;
        margin-top: -120px;
        text-align: right;
        margin-bottom: 60px;
    }
    .service > div > .box2 > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .facirclecheck-service {
        margin-right: 4px;
        margin-top: 4px;
        font-weight: bolder;
        color: #2d4f98;
        width: 15px;
        height: 15px;
        float: left;
    }
    .cobertura-principal {
        width: 100%;
        padding: 0px 300px;
    }
    .cobertura-principal > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
    }
    .cobertura-principal > div {
        display: flex;
        margin-bottom: 50px;
    }
    .cobertura-principal > div > center > img {
        width: 200px;
        height: auto;
    }
    .cobertura-principal > div > div {
        padding: 20px;
    }
    .cobertura-principal > div > div > div > img{
        width: 50px;
        margin-right: 20px;
    }
    .cobertura-principal > div > div > div > label{
        font-family: 'JBD';
        color: #65b24a;
        font-size: 20px;
    }
    .cobertura-principal > div > div > p{
        padding: 25px;
        margin-top: 20px;
        font-family: 'JR';
        -webkit-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        -moz-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
    }
    .cobertura-principal-slide{
        padding: 0px 300px;
    }
    .cobertura-principal-slide > div {
        display: flex;
    }
    .cobertura-principal-slide > div > label {
        color: #65b24a;
        font-family: 'JBD';
        font-size: 20px;
    }
    .cobertura-principal-slide > div > img {
        width: 50px;
    }
    .cobertura-principal-slide > p {
        font-family: 'JR';
        margin-top: 10px;
        margin-bottom: 60px;
    }
    .slide-cobertura-opcional > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .opcionales {
        padding: 50px 300px;
        font-family: 'JR';
    }
    .opcionales > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-bottom: 20px;
    }
    .opcionales > .opcional > .subopcional {
        padding-left: 50px;
    }
    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }
    .connect > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }
    .connect > h1 {
        font-family: 'JBD';
        padding-top: 50px;
        padding-left: 200px;
        color: #65b24a;
    }
    .connect > p{
        font-family: 'JR';
        padding-left: 200px;
        width: 80%;
        color: #fff;
        font-size: 22px;
        line-height: 25px;
    }
    .move > center > img {
        margin-top: 30px;
        width: 800px;
    }
    @media (max-width: 1500px) {
        .title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
        .info > p {
            padding-left: 200px;
        }
        .services {
            padding: 50px 200px;
            width: 100%;
        }
    }
    @media (max-width: 1400px) {
        .title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
        .info > p {
            padding-left: 100px;
        }
        .services {
            padding: 50px 100px;
            width: 100%;
        }
        .service {
            padding: 20px 150px;
            width: 100%;
        }
    }
    @media (max-width: 1300px) {
        .info > h1 {
            font-size: 30px;
        }
        .info > p {
            width: 50%;
        }
        .services {
            padding: 50px 50px;
            width: 100%;
        }
        .texto {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal-slide{
            padding: 0px 200px;
        }
        .opcionales {
            padding: 50px 200px;
        }
    }
    @media (max-width: 1200px) {
        .service {
            padding: 20px 75px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 10%;
        }
    }
    @media (max-width: 1100px) {
        .service {
            padding: 20px 50px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 5%;
        }
        .connect > h1 {
            padding-top: 10px;
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        .connect > p{
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
    }
    @media (max-width: 1000px) {
        .title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            width: 100%;
            text-align: center;
        }
        .top {
            padding-top: 400px;
        }
        .info > h1 {
            padding: 10px;
            width: 100%;
        }
        .info > p {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
        .texto {
            width: 100%;
            padding: 10px 100px;
        }
        .services {
            padding: 0px 50px;
        }
        .service {
            padding: 20px 25px;
            width: 100%;
        }
        .connect > h1 {
            padding-left: 50px;
            font-size: 30px;
        }
        .connect > p{
            padding-left: 50px;
            font-size: 18px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 100px;
        }
        .cobertura-principal-slide{
            padding: 0px 100px;
        }
        .opcionales {
            padding: 50px 100px;
        }
    }
    @media (max-width: 900px) {
        .colectivo > center > div {
            display: block;
        }
        .move > center > img {
            width: 700px;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
        .service > div {
            display: grid;
        }
        .service > div > .box{
            margin-left: 0px;
            margin-top: 0px;
            width: 100%;
            padding: 30px 30px 30px 30px;
        }
        .service > div > .box2 {
            margin-right: 0px;
            margin-top: 0px;
            background-color: #fff;
            width: 100%;
            padding: 30px 30px 100px 30px;
        }
        .service > div > .imgbox {
            display: block;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .service > div > .imgbox > img{
            width: 250px;
            margin: auto;
        }
        .service > div > .right{
            position: relative;
            right: 0px;
        }
        .service > div > .box2 > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .service > div > .box > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .cobertura-principal > div {
            display: block;
        }
        .move > center > img {
            width: 600px;
        }
    }
    @media (max-width: 700px) {
        .texto {
            width: 100%;
            padding: 10px 50px;
        }
        .cobertura-principal {
            padding: 10px 50px;
        }
        .cobertura-principal-slide {
            padding: 0px 50px;
        }
        .opcionales {
            padding: 50px 50px;
        }
        .move > center > img {
            width: 500px;
        }
    }
    @media (max-width: 600px) {
        .connect > h1 {
            font-size: 18px;
        }
        .connect > p{
            font-size: 18px;
            width: 100%;
        }
        .services > center > div > div {
            width: 70%;
        }
        .move > center > img {
            width: 400px;
        }
    }
    @media (max-width: 500px) {
        .texto > .box-title > h1 {
            font-size: 30px;
        }
        .texto > center > h1 {
            font-size: 30px;
        }
        #contactForm {
            width: 300px;
        }
        .connect > h1 {
            padding-left: 25px;
        }
        .connect > p{
            padding-left: 25px;
        }
        .services > center > div > div {
            width: 80%;
        }
        .slide-cobertura-opcional > center > h1 {
            font-size: 30px;
        }
        .cobertura-principal > center > h1{
            font-size: 30px;
        }
        .opcionales > center > h1 {
            font-size: 30px;
        }
        .move > center > img {
            width: 300px;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div {
            width: 90%;
        }
        .connect > p{
            padding-left: 5px;
            font-size: 16px;
            line-height: 19px;
        }
        .move > center > img {
            width: 250px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosEmpresas/cumplimientoDisposicionesLegal.vue